<template>
    <el-dialog :title="titleDialog" :visible="dialogVisible" @open="create" @close="close" top="8vh">
        <div class="form-body">
            <div class="row">

                <div class="col-12">
                    <div class="form-group">
                        <el-switch v-model="search_item_by_barcode"
                            :disabled="data_item"
                        ></el-switch>
                        <label class="control-label">
                            Buscar por código de barras
                        </label>
                    </div>
                </div>

                <div class="col-12">
                    <div class="form-group" :class="{'has-danger': errors.item}">
                        <label class="control-label">
                            Producto <span class="text-danger">*</span>
                            <span v-if="data_item">[ + Nuevo]</span>
                            <a v-else href="#" @click.prevent="showDialogNewItem = true">[+ Nuevo]</a>
                        </label>
                        <el-select ref="select_item"
                            v-model="form.item"
                            filterable
                            @change="onChangeItem"
                            remote
                            :remote-method="searchRemoteItems"
                            :loading="loading_search"
                            :disabled="data_item"
                        >
                            <el-option v-for="option in items" :key="option.id" :value="option.id" :label="option.full_description"></el-option>
                        </el-select>
                        <small class="form-control-feedback" v-if="errors.items" v-text="errors.items"></small>
                    </div>
                </div>

                <!-- <template v-if="item"> -->

                    <div class="col-lg-6">
                        <div class="form-group" :class="{'has-danger': errors.quantity}">
                            <label class="control-label">Cantidad <span class="text-danger">*</span></label>
                            <el-input-number v-model="form.quantity" :precision="4" :step="1" :min="0.01" :max="99999999"></el-input-number>
                            <small class="form-control-feedback" v-if="errors.quantity" v-text="errors.quantity[0]"></small>
                        </div>
                    </div>
                    <template v-if="item">
                        <div class="col-12 mt-2" v-if="item.lots_enabled && item.lots_group.length > 0">
                            <a href="#"  class="text-center font-weight-bold text-info" @click.prevent="clickLotGroup">[&#10004; Seleccionar lote]</a>
                        </div>
                    </template>

                    <div class="col-lg-6">
                        <div class="form-group" :class="{'has-danger': errors.item_weight}">
                            <label class="control-label">Peso</label>
                            <el-input-number v-model="form.item_weight" :precision="4" :step="1" :min="0" :max="99999999"></el-input-number>
                            <small class="form-control-feedback" v-if="errors.item_weight" v-text="errors.item_weight[0]"></small>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="form-group">
                            <label class="control-label">Nombre producto en PDF</label>

                            <vue-ckeditor
                                v-model="form.name_product_pdf"
                                :editors="editors"
                                type="classic"></vue-ckeditor>
                        </div>
                    </div>

                <!-- </template> -->
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click.prevent="close">Cerrar</el-button>
            <el-button type="primary" @click="clickAddItem">{{ labelButton }}</el-button>
        </span>

        <item-form :showDialog.sync="showDialogNewItem" :external="true"></item-form>

        <lots-group
            v-if="item"
            :quantity="form.quantity"
            :showDialog.sync="showDialogLots"
            :lotsGroup="item.lots_group"
            @addRowLotGroup="addRowLotGroup">
        </lots-group>
    </el-dialog>
</template>

<script>
    import itemForm from '../items/form.vue';
    import LotsGroup from '../documents/partials/lots_group.vue';
    import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
    import VueCkeditor from "vue-ckeditor5";

    export default {
        components: {itemForm, LotsGroup, 'vue-ckeditor': VueCkeditor.component},
        props: ['dialogVisible','data_item', 'name_pdf_description'],
        data() {
            return {
                titleDialog: 'Agregar Producto',
                showDialogNewItem: false,
                all_items: [],
                resource: 'dispatches',
                errors: {},
                items: [],
                form: this.blankForm(),
                showDialogLots: false,
                item: null,
                loading_search:false,
                search_item_by_barcode: false,
                editors: {
                    classic: ClassicEditor
                },
                labelButton: null
            }
        },
        mounted() {
            this.$eventHub.$on('reloadDataItems', (item_id) => {
                this.reloadDataItems(item_id)
            })
        },
        methods: {
            blankForm() {
                return {
                    item: null,
                    quantity: 1,
                    item_weight: 1,
                    IdLoteSelected: null,
                    name_product_pdf: ''
                }
            },
            clickLotGroup() {
                this.showDialogLots = true
            },
            onChangeItem() {
                this.form.IdLoteSelected = null;
                this.item = this.items.find(it => it.id == this.form.item)
                
                if (this.name_pdf_description) {
                    this.form.name_product_pdf = this.item.description
                }

                if (this.data_item) {
                    if (this.data_item.item_id !== this.item.id) {
                        this.form.quantity = 1
                        this.form.item_weight = 0
                        this.form.IdLoteSelected = null
                        this.form.name_product_pdf = ''
                    } else {
                        this.form.quantity = this.data_item.quantity
                        this.form.item_weight = this.data_item.item_weight
                        this.form.IdLoteSelected = this.data_item.IdLoteSelected
                        this.form.name_product_pdf = this.data_item.name_pdf
                    }
                }
            },
            addRowLotGroup(id) {
                this.form.IdLoteSelected =  id;
            },
            async create() {
                // this.$http.post(`/${this.resource}/tables`).then(response => {
                //     this.items = response.data.items;
                //     this.all_items = this.items
                // });

                // // this.form = {};
                // this.form = this.blankForm()

                // if (this.data_item) {
                //     this.form.item = this.data_item.item_id
                //     this.form.quantity = this.data_item.quantity
                //     this.form.item_weight = this.data_item.item_weight
                //     this.form.IdLoteSelected = this.data_item.IdLoteSelected
                //     this.form.name_product_pdf = this.data_item.name_pdf
                //     this.item = this.items.find(it => it.id == this.form.item)
                // }
                if (this.data_item) {
                    this.titleDialog = 'Editar Producto'
                    this.labelButton = 'Actualizar'
                } else {
                    this.titleDialog = 'Agregar Producto'
                    this.labelButton = 'Agregar'
                }

                try {
                    const response = await this.$http.post(`/${this.resource}/tables`)
                    this.items = response.data.items || []
                    this.all_items = [...this.items]

                    this.form = this.blankForm()

                    if (this.data_item) {
                        const { item_id, quantity, item_weight, IdLoteSelected, name_pdf, description } = this.data_item
                        let d_description = description
                        if (!this.name_pdf_description) {
                            d_description = ''
                        }
                        Object.assign(this.form, {
                            item: item_id,
                            quantity,
                            item_weight,
                            IdLoteSelected,
                            name_product_pdf: name_pdf ? name_pdf : d_description
                        })
                        this.item = this.items.find(it => it.id == this.form.item) || null

                        if (!this.item && this.form.item) {
                            const response = await this.$http.get(`/documents/search/item/${this.form.item}`)
                            const extraItem = (response.data.items || [])[0]
                            if (extraItem) {
                                const existsInItems = this.items.some(it => it.id == extraItem.id)
                                const existsInAllItems = this.all_items.some(it => it.id == extraItem.id)
                                if (!existsInItems) {
                                    this.items.unshift(extraItem)
                                }
                                if (!existsInAllItems) {
                                    this.all_items.unshift(extraItem)
                                }

                                this.item = extraItem
                            }
                        }
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            close() {
                this.item = null
                this.$emit('update:dialogVisible', false);
            },
            clickAddItem() {
                this.errors = {};

                if(this.item.lots_enabled){
                    if(! this.form.IdLoteSelected)
                        return this.$message.error('Debe seleccionar un lote.');
                }

                if ((this.form.item != null) && (this.form.quantity != null || this.form.quantity > 0)) {
                    this.form.quantity = Math.abs(this.form.quantity)
                    if(isNaN(this.form.quantity))this.form.quantity = 0;
                    if(isNaN(this.form.item_weight))this.form.item_weight = 0;
                    const item = this.items.find((item) => item.id == this.form.item)
                    item.IdLoteSelected = this.form.IdLoteSelected;
                    item.unit_price = item.sale_unit_price;
                    item.total_value = item.sale_unit_price*this.form.quantity;
                    item.name_pdf = this.form.name_product_pdf
                    item.name_product_pdf = this.form.name_product_pdf
                    this.$emit('addItem', {
                        item,
                        quantity: this.form.quantity,
                        item_weight: this.form.item_weight,
                        is_edit: this.data_item ? true : false,
                    });

                    // this.form = {};
                    this.form = this.blankForm()
                    this.item = null;
                    return;
                }

                if (this.form.item == null) this.$set(this.errors, 'items', ['Seleccione el producto']);

                if (this.form.quantity == null) this.$set(this.errors, 'quantity', ['Digite la cantidad']);

                this.form.IdLoteSelected = null;
            },
            filterItems() {
                this.items = this.all_items
            },
            async searchRemoteItems(input) {
                if (input.length > 2) {
                    this.loading_search = true
                    const params = {
                        'input': input,
                        'search_by_barcode': this.search_item_by_barcode ? 1 : 0
                    }
                    await this.$http.get(`/documents/search-items`, { params })
                            .then(response => {
                                this.items = response.data.items
                                this.loading_search = false
                                // this.enabledSearchItemsBarcode()
                                this.selectedItembyBarcode()
                                if(this.items.length == 0){
                                    this.filterItems()
                                }
                            })
                } else {
                    await this.filterItems()
                }

            },

            selectedItembyBarcode() {
                if (this.search_item_by_barcode && this.items.length == 1) {
                    // this.item = this.items[0]
                    this.$set(this.form, 'item', this.items[0].id)
                    this.onChangeItem()
                    this.$refs.select_item.blur()
                }
            },

            async reloadDataItems(item_id) {

                if (!item_id) {

                    await this.$http.get(`/documents/table/items`).then((response) => {
                        this.items = response.data
                        this.form.item_id = item_id
                        // if(item_id) this.changeItem()
                        // this.filterItems()
                    })

                } else {

                    await this.$http.get(`/documents/search/item/${item_id}`).then((response) => {

                        this.items = response.data.items
                        this.form.item = item_id
                        this.onChangeItem()

                    })
                }

            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/views/tenant/dispatches/items.vue